<template>
  <div v-if='wo' :class="wo.is_complete ? 'grey lighten-3' : ''">
    <wc-page-title :loading='isLoading' :title='title' :subtitle='subtitle' :class="wo.is_complete ? 'grey lighten-3' : ''">
      <template v-slot:rightSide>
        <div style='max-width: 110px'>
          <v-btn
            small
            elevation='0'
            width='100px'
            class='mb-2'
            outlined
            color='info'
            :disabled='!wo.project && !wo.estimate'
            @click='getDirections()'
          >
            Directions
          </v-btn>
          <v-btn
            v-if='wo.project && wo.project_obj.division_obj.division === "Irrigation"'
            small
            elevation='0'
            width='100px'
            class='mb-2'
            outlined
            color='success'
            :disabled='wo.asbuilt === null || wo.asbuilt === undefined'
            @click='getAsbuilt()'
          >
            Asbuilt
          </v-btn>
          <v-btn
            small
            elevation='0'
            width='100px'
            class='mb-0'
            outlined
            color='orange'
            @click='returnToRoute()'
          >
            Schedule
          </v-btn>
        </div>
      </template>
    </wc-page-title>
    <router-view
      class='mt-n6'
      v-if='wo'
      :wo='wo'
      :woType='getWOType(wo)'
      :productList='productList'
      :product='product'
      :labour='labour'
      :crewVisits='crewVisits'
      @updateProduct='updateProduct'
      @updateLabour='updateLabour'
      @deleteLabour='deleteLabour'
      @completeWO='completeWO'
      @couldntCompleteWO='couldntCompleteWO'
      @getUpdatedWO='getUpdatedWO'
      @updateWO="updateWO"
    ></router-view>
    <wc-dialog
      title='Time on Site'
      :showDialog='show_time'
      :loadingButtons='false'
      :body_text="`<p>You have been on site for ${getTimeDifference}. </p> <p> Please make sure completed all applicable information. Go back to WO to complete if you have not.</p>`"
      saveText='Confirm'
      cancelText="Back to WO"
      @cancel='backtoWO()'
      @save='confirmTime()'
      width='350'
    />
  </div>
</template>

<script>
import wosAPI from '@/modules/wos/api'
import moment from 'moment';
import assetsAPI from '@/modules/assets/api/inventory'
import miscServices from '@/services/misc'
import filesAPI from '@/api/files'
import _ from 'lodash'

export default {
  name: 'woCard-detail-base',
  data: () => ({
    isLoading: true,
    wo: null,
    productList: [],
    product: [],
    labour: [],
    crewVisits: [],
    show_time: false
  }),
  computed: {
    getTimeDifference(){
        const end_time = moment(this.wo.end_time);
        const start_time = moment(this.wo.start_time);
        var duration = moment.duration(end_time.diff(start_time));
        return Math.floor(duration.asMinutes()) + " minutes";
    },
    title () {
      if (this.wo && this.wo.project) {
        return this.wo.project_obj.name
      } else if (this.wo && this.wo.estimate) {
        return this.wo.estimate_obj.name
      }
      return ''
    },
    subtitle () {
      if (this.wo && this.wo.project) {
        return this.wo.project_obj.site_address
      } else if (this.wo && this.wo.estimate && this.wo.estimate_obj.project) {
        return this.wo.estimate_obj.project_obj.site_address
      } else if (this.wo && this.wo.estimate) {
        return this.wo.estimate_obj.site_address
      } 
      return ''
    },
    woTypes () {
      return _.orderBy(this.$store.state.misc.woTypes, 'name')
    },
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading
      this.wo = await wosAPI.getWO(this.$route.params.id)
      // not getting Labour list - for now
      let tmp = await assetsAPI.getInventory()
      let product = _.filter(tmp, p => !p.is_estimate_only)
      product = _.filter(tmp, p => !p.archived)
      this.productList = _.orderBy(product, 'app_order')
      this.labour = await wosAPI.getLabourForWO(this.wo.id)
      this.product = await wosAPI.getProductForWO(this.wo.id)
      this.crewVisits = await wosAPI.getCrewVisitsForWO(this.wo.id)
      this.isLoading = false;
    },
    async getUpdatedWO () {
      this.isLoading = true
      this.wo = await wosAPI.getWO(this.$route.params.id)
      this.isLoading = false
    },
    async updateWO(wo){
        this.wo = wo;
    },
    async completeWO (woCopy) { 
      this.isLoading = true;
      await wosAPI.completeWO(woCopy);
      this.isLoading = false;
      this.show_time = true;
    },
    async couldntCompleteWO(woCopy){
      this.isLoading = true;
      await wosAPI.couldntCompleteWO(woCopy);
      this.isLoading = false;
      this.show_time = true;
    },
    async confirmTime(){
        this.returnToRoute();
    },
    async backtoWO(){
        this.show_time=false;
        this.show_
    },
    async updateProduct (product) {
      this.isLoading = true
      this.product = await wosAPI.woProductExchange(this.wo.id, product)
      this.isLoading = false
    },
    async deleteLabour (objID) {
      this.isLoading = true
      let tmp = await wosAPI.deleteLabourForWO(objID)
      miscServices.removeObject(this.labour, tmp)
      this.isLoading = false
    },
    async updateLabour (obj) {
      this.isLoading = true
      if (obj.id) {
        let tmp = await wosAPI.updateLabourForWO(obj)
        miscServices.replaceObject(this.labour, tmp)
      } else {
        obj.work_order = this.wo.id
        obj.added_by = this.$store.state.auth.profile.id
        this.labour.push(await wosAPI.createLabourForWO(obj))
      }
      this.isLoading = false
    },
    getWOType (wo) {
      return _.find(this.woTypes, function(w) { return w.id === wo.wo_type })
    },
    getDirections () {
      let URL = ""
      if (this.wo.project) {
        if (this.wo.project_obj.lat !== 0) {
          URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.wo.project_obj.lat + '+' + this.wo.project_obj.lng
        } else {
          URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.wo.project_obj.site_address + '+' + this.wo.project_obj.site_city
        }
      } else if (this.wo.estimate) {
        if (this.wo.estimate_obj.lat !== 0) {
          URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.wo.estimate_obj.lat + '+' + this.wo.estimate_obj.lng
        } else {
          URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.wo.estimate_obj.site_address + '+' + this.wo.estimate_obj.site_city
        }
      }
      window.open(URL, '_blank', )
    },
    async getAsbuilt () {
      const downloadURL = await filesAPI.downloadFile(this.wo.asbuilt.file)
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = downloadURL
      link.click()
    },
    returnToRoute () {
      this.$router.push({ name: 'FieldRoute', params: { id: this.wo.route_obj.id } })
    }
  }
}
</script>
